import { ROUTE_NAMES_LEGACY_FALLBACK } from '@atlassian/jira-common-constants/src/spa-routes';

export const legacyFallbackRoute = {
	name: ROUTE_NAMES_LEGACY_FALLBACK,
	path: '/:any',
};
